const filter = document.querySelector('.hero-sub-page__filter');

if (filter) {
  const calcFilterHeight = () => {
    filter.closest('.hero-sub-page__filter-wrap').style.height = `${filter.offsetHeight}px`;
  };
  calcFilterHeight();

  window.addEventListener('resize', calcFilterHeight);
}
